"use client"

import { StackedLayout } from "components/catalyst/stacked-layout";
import { 
  Navbar, 
  NavbarDivider, 
  NavbarItem, 
  NavbarLabel, 
  NavbarSection, 
  NavbarSpacer 
} from 'components/catalyst/navbar'
import { 
  Sidebar, 
  SidebarBody, 
  SidebarHeader, 
  SidebarItem, 
  SidebarLabel, 
  SidebarSection,
  SidebarDivider,
  SidebarFooter
} from 'components/catalyst/sidebar'
import { Avatar } from 'components/catalyst/avatar'
import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from 'components/catalyst/dropdown'
import {
  ChevronDown,
  Settings,
  Plus,
  User,
  Shield,
  Lightbulb,
  LogOut,
  Search,
  Inbox,
  Settings2Icon,
  SettingsIcon,
  StarIcon
} from 'lucide-react'
import { HamburgerMenuIcon } from "@radix-ui/react-icons";
import { useState, useContext } from 'react';
import { AppProvider } from "contexts/AppContext";
import { AppContext } from 'contexts/AppContext';
import logo_mini from 'img/logo_mini.png'
import { Link, useLocation } from 'react-router-dom';
import { ClientDropdownMenu } from './ClientDropdown'
import { SettingsDropdownMenu } from './SettingsDropdown'
import { useAuth0 } from '@auth0/auth0-react';

export default function RootLayout({ children }) {

  return (
    <html className="bg-white lg:bg-zinc-100 dark:bg-zinc-900 dark:lg:bg-zinc-950">
      <body>
        <RootContent children={children}/>
      </body>
    </html>
  );
}

function RootContent({ children }) {

  // Empty deliberately. "Home" (`/`) and "Monitoring" (`/monitoring`) both
  // rendered <MonitoringPage /> — see App.js — so the two links were a choice
  // between identical destinations, which reads as a bug the first time you
  // click one. Both routes stay; only the redundant chrome is gone.
  //
  // Kept as an array rather than deleting the map: the console gains a second
  // real destination the moment anything lives outside /monitoring, and this
  // is where it goes.
  const navItems = []

  const { getAccessTokenSilently } = useAuth0();
  
  const fetchData = async () => {
    const token = await getAccessTokenSilently();
    // Use token for API calls
  };

  return (
    <StackedLayout
    navbar={
      <Navbar>
        <img src={logo_mini} className="w-5 h-5 ml-5"/>
        <NavbarLabel>Instalily Console</NavbarLabel>
        {/* Both hidden when there are no items, or the divider is left
            floating next to the wordmark with nothing after it. */}
        {navItems.length > 0 && <NavbarDivider className="max-lg:hidden" />}
        <NavbarSection className="max-lg:hidden">
            {navItems.map(({ label, url }) => (
              <NavbarItem key={label}>
                <Link to={url} className="text-inherit no-underline">
                  {label}
                </Link>
              </NavbarItem>
            ))}
          </NavbarSection>
        <NavbarSpacer />
        <NavbarSection className="max-lg:hidden">
            <ClientDropdownMenu />
        </NavbarSection>
        <SettingsDropdownMenu/>
      </Navbar>
    }
    sidebar={
      <Sidebar>
        <SidebarBody>
            {/* Same conditional as the navbar: with no items the section and
                its divider would render as an empty block above the client
                picker on mobile. */}
            {navItems.length > 0 && (
              <>
                <SidebarSection>
                  {navItems.map(({ label, url }) => (
                    <SidebarItem key={label}>
                      <Link to={url} className="text-inherit no-underline">
                        {label}
                      </Link>
                    </SidebarItem>
                  ))}
                </SidebarSection>
                <SidebarDivider/>
              </>
            )}
            <ClientDropdownMenu />
        </SidebarBody>
      </Sidebar>
    }
  >
    {children}
  </StackedLayout>
  );
}
